import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import { Cancel, Compare } from '@one-thd/sui-icons';
export var SubstitutionBadges = function (_a) {
    var _b, _c, _d;
    var type = _a.type;
    var badges = {
        'Out of Stock': {
            color: 'danger',
            text: 'Out of Stock',
            icon: React.createElement(Cancel, null),
        },
        'Substituted Item': {
            color: 'success',
            text: 'Substituted Item',
            icon: React.createElement(Compare, null),
        },
        'Substitute if out of stock': {
            color: 'success',
            text: 'Substitute if out of stock',
            icon: React.createElement(Compare, null),
        },
    };
    return (React.createElement("div", { style: {
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
        } },
        React.createElement(Badge, { variant: "regular", style: { fontSize: '12px' }, size: "base", color: (_b = badges[type]) === null || _b === void 0 ? void 0 : _b.color, startIcon: (_c = badges[type]) === null || _c === void 0 ? void 0 : _c.icon }, (_d = badges[type]) === null || _d === void 0 ? void 0 : _d.text)));
};
